import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PrivateattendancestdComponent } from './privateattendancestd.component';

const routes: Routes = [{ path: '', component: PrivateattendancestdComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PrivateattendancestdRoutingModule { }
